import React from 'react';
import {Link} from 'react-router';
import fileDownload from 'js-file-download';
import { ShowIf } from 'components/utils';
import { checkServerLive } from 'constants/config';
import {downloadFile} from 'components/utils';

export default class RowItemDocumentDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    if (!this.props.item) {
      return null;
    }
    return (
      <tr>
        <td>{this.props.count || ''}</td>
        <td>{(this.props.item.donViXuLyInfo && this.props.item.donViXuLyInfo.ten) || ''}</td>
        <td>{(this.props.item.tenInfo && this.props.item.tenInfo.ten) || ''}</td>
        <td>
            {/* { this.props.item.listTaiLieuVanThus && this.props.item.listTaiLieuVanThus.length > 0 &&
              <Link className='txt-underline' onClick={fileDownload.bind(this, this.props.item.listTaiLieuVanThus[0].duongDan, this.props.item.listTaiLieuVanThus[0].tenFile)} >{this.props.item.listTaiLieuVanThus[0].tenFile}</Link>
            } */}
            <ShowIf condition={this.props.item.listTaiLieuVanThus && this.props.item.listTaiLieuVanThus.length > 0}>
              <ShowIf condition={!checkServerLive}>
                <Link className='txt-underline' onClick={fileDownload.bind(this, this.props.item.listTaiLieuVanThus[0].duongDan, this.props.item.listTaiLieuVanThus[0].tenFile)} >{this.props.item.listTaiLieuVanThus[0].tenFile || ''}</Link>
              </ShowIf>
              <ShowIf condition={checkServerLive}>
                <Link className='txt-underline' onClick={()=>{downloadFile(this.props.item.listTaiLieuVanThus[0].duongDan, this.props.item.listTaiLieuVanThus[0].tenFile)}} >{this.props.item.listTaiLieuVanThus[0].tenFile || ''}</Link>
              </ShowIf>
            </ShowIf>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/dialog/table-row/RowItemDocumentDetail.jsx